import React, { useEffect, useState } from "react";
import { getUserDetails } from "../../../api/lead";
import "../../leads/lead-filter/lead-filter-options/created-by-filter.scss";
import MultiSelectAutocomplete from "../../../common/components/autocomplete-component/autocomplete";
interface CreatedByOption {
  value: number;
  label: string;
}

interface CreatedByFilterProps {
  value: number[];
  onChange: (value: number[]) => void;
  isCreatedByEnabled?: boolean;
  createdByUserIdsError?: any;
    setAlertMessage: any;
  setAlertType: any;
  setAlertOpen: any;
}

const CreatedByFilter: React.FC<CreatedByFilterProps> = ({
  value,
  onChange,
  isCreatedByEnabled,
  createdByUserIdsError,
   setAlertMessage,
    setAlertType,
    setAlertOpen
}) => {
  const [options, setOptions] = useState<CreatedByOption[]>([]);

  useEffect(() => {
    if (!isCreatedByEnabled) return;

    const fetchCreatedByOptions = async () => {
      try {
      const response = await getUserDetails({}, "Lead Capture");
      const data = response.data.data.data.data;
      const formattedOptions = data.map((user: any) => ({
        value: user.id,
        label: `${user.first_name} ${user.last_name}`,
      }));

      setOptions([...formattedOptions]);
      } catch (error: any) {
        setAlertMessage(error?.response?.data?.message || "Something went wrong please try again.");
        setAlertType("error");
        setAlertOpen(true);
      }
    };

    fetchCreatedByOptions();
  }, [isCreatedByEnabled]);

  if (!isCreatedByEnabled) return null;



  return (
    <div className="filter-select-input-wrapper">
      <MultiSelectAutocomplete
        options={options}
        selectedValues={value}
        onChange={onChange}
        placeholder="Select Created By"
      />
      {createdByUserIdsError && <div className="error-text">{createdByUserIdsError}</div>}
    </div>


  );
};

export default CreatedByFilter;
